import * as React from "react";
import PropTypes from 'prop-types';

const SvgLockWhite = props => {
  if (props.id !== "_svglockwhite") {
    throw new Error('SVG requires <Icon> component as a parent, e.g. <Icon><SvgLogo></Icon>');
  }

  return <svg viewBox="0 0 48 48" {...props}><g fill="none" fillRule="evenodd"><path d="M0 0h48v48H0z" /><g transform="translate(14 11)" fill="#FFF"><rect y={10} width={20} height={16} rx={2} /><path d="M6 7.006v9.988A4.004 4.004 0 0010 21c2.204 0 4-1.796 4-4.006V7.006A4.004 4.004 0 0010 3C7.796 3 6 4.796 6 7.006zm-3 0C3 3.136 6.142 0 10 0c3.866 0 7 3.138 7 7.006v9.988C17 20.864 13.858 24 10 24c-3.866 0-7-3.138-7-7.006V7.006z" fillRule="nonzero" /></g></g></svg>;
};

SvgLockWhite.displayName = "_svglockwhite";
SvgLockWhite.propTypes = {
  id: PropTypes.string
};
SvgLockWhite.defaultProps = {
  id: ''
};
export default SvgLockWhite;